import { render, staticRenderFns } from "./product-introduct.vue?vue&type=template&id=182ed193&scoped=true&"
import script from "./product-introduct.vue?vue&type=script&lang=js&"
export * from "./product-introduct.vue?vue&type=script&lang=js&"
import style0 from "./product-introduct.vue?vue&type=style&index=0&id=182ed193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ed193",
  null
  
)

export default component.exports